import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { TextField } from "@mui/material";
import { useAppDispatch } from "../../../redux/store";
import { setItem } from "../../redux/createOpinionReducer";
import Section from "../editors/Section";
import { styles } from "../editors/Styles";

export default function Details() {
  const dispatch = useAppDispatch();

  const post = useSelector((state: any) => state.createOpinion.values);
  const details = post.details;
  const error = useSelector((state: any) => state.createOpinion.errors.details);

  const handleChangeDetails = (value: string) => {
    dispatch(setItem({key: 'details', value: value}))
  }

  return (
    <Section
      title={`${T("mng_details")}${T("required")}`}
      body={
        <TextField
          onChange={(e) => handleChangeDetails(e.target.value)}
          inputProps={{ maxLength: 2500 }}
          sx={ styles.inputField }
          hiddenLabel
          multiline
          value={details}
          rows={7}
          FormHelperTextProps={{ style: styles.errorOnInputField }}
          error={!!error}
          helperText={error}
        />
      }
    />
  )
}
